module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[79]200.a8a4f63.woff2";